import { Formik, useFormikContext } from "formik";
import { get } from "lodash";
import React, { useState } from "react";
import { useContext } from "react";
import { Image, InputGroup } from "react-bootstrap";
import { manageMapperStore } from "../../../contexts";
import { isNull } from "lodash-es";
import { AddToolTip, FormControlSearch } from "../../../components";
import {
  Census,
  CensusAndPayroll,
  CensusFilterData,
  Payroll,
} from "../../../utils";

const ClickToSelectFunctionSlider = ({
  objName,
  setOpenSlider,
  openSlider,
  fieldName,
  index,
  setShowSlider,
  showSlider,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const { state, dispatch } = useContext(manageMapperStore);
  const dataModel = get(state, "api.data.dataModel", "");
  const data = get(state, "api.data", []);
  const parseHeaderMapJson = JSON.parse(data?.headerMapJson);
  const model =
    data?.mapType == 3
      ? parseHeaderMapJson
      : dataModel === 2
      ? Census
      : dataModel === 1
      ? Payroll
      : CensusAndPayroll;

  const [functionData, setFunctionData] = useState(model);

  const onSelectClick = (item, propName, isCollection) => {
    isNull(index)
      ? setFieldValue(`${objName}.value`, {
          id: item.id,
          displayName: item.displayName,
          path: item.propertyName,
          propertyName: item.propertyName,
          dataType: item.dataType,
          datum: item.datum,
          propertyNameParent: propName,
          isCollection: isCollection,
        })
      : setFieldValue(`${fieldName}.value`, {
          id: item.id,
          displayName: item.displayName,
          propertyName: item.propertyName,
          path: item.propertyName,
          dataType: item.dataType,
          datum: item.datum,
          propertyNameParent: propName,
          isCollection: isCollection,
        });

    setOpenSlider(false);
  };

  const handleSearch = (searchValue) => {
    const filteredValues = model.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(searchValue.toLowerCase());
    });
    setFunctionData(filteredValues);
  };

  return (
    <>
      <div>
        <p className="ft-14 fw-500 mb-3 mt-2">Select Source Fields</p>
        <div className="border-line-seperator mb-3" />
        {/* <input
          icon="search"
          className="searchBox"
          style={{ width: "29rem" }}
          placeholder="Search source fields here"
          onChange={(e) => handleSearch(e.target.value)}
        /> */}
        <InputGroup>
          <InputGroup.Prepend>
            <div className="passthrough-search-icon-postion">
              <i class="fal fa-search" aria-hidden="true"></i>
            </div>
          </InputGroup.Prepend>
          <FormControlSearch
            size="sm"
            id="source-search-box"
            type="text"
            screen={"passthrough"}
            placeholder="Search source fields here"
            className="source-search-box pl-5 p-3 w-100"
            onChange={(e) => handleSearch(e.target.value)}
            autoComplete="off"
          />
        </InputGroup>

        <div className="function-list-container mt-2">
          {functionData.map((item) => {
            if (!item.isCollection) {
              return (
                <div
                  className="function-list cursor-pointer"
                  onClick={() => {
                    onSelectClick(item, item.propertyName, item.isCollection);
                    //!item.isCollection && setShowSlider(false);
                    !item.isCollection
                      ? setShowSlider(false)
                      : objName === "valueData"
                      ? setShowSlider(true)
                      : setShowSlider(false);
                    // (objName === "valueData" ) ? setShowSlider(true) : setShowSlider(false);
                  }}
                >
                  <div className="d-flex flex-column justify-content-between">
                    <p className="ft-14 mb-1" style={{ width: "fit-content" }}>
                      {data?.mapType == 3 ? (
                        <AddToolTip name={item?.fieldName?.substring(1)}>
                          {item?.fieldName?.substring(1).length > 15
                            ? item?.fieldName?.substring(1).slice(0, 15) + "..."
                            : item?.fieldName?.substring(1)}
                        </AddToolTip>
                      ) : (
                        item.displayName
                      )}
                    </p>
                    <p className="ft-12 mb-1" style={{ width: "fit-content" }}>
                      <AddToolTip name={item.datum}>
                        {item.datum.length > 15
                          ? item.datum.slice(0, 15) + "..."
                          : item.datum}
                      </AddToolTip>
                    </p>
                  </div>
                </div>
              );
            } else if (objName === "valueData") {
              return (
                <>
                  {item.childObjectMaps?.map((subHead, ind) => {
                    return (
                      <div
                        className="function-list cursor-pointer"
                        onClick={() => {
                          onSelectClick(
                            subHead,
                            item.propertyName,
                            item.isCollection
                          );
                          !item.isCollection
                            ? setShowSlider(false)
                            : objName === "valueData"
                            ? setShowSlider(true)
                            : setShowSlider(false);
                          //!item.isCollection && setShowSlider(false);
                          // (objName === "valueData") ? setShowSlider(true) : setShowSlider(false);
                        }}
                      >
                        <div className="d-flex flex-column justify-content-between">
                          <p className="ft-14 mb-1">{subHead.displayName}</p>
                          <p className="ft-12 mb-1">{subHead.datum}</p>
                        </div>
                      </div>
                    );
                  })}
                </>
              );
            }
          })}
        </div>
      </div>
    </>
  );
};

export default ClickToSelectFunctionSlider;
